<template>
  <div class="gallery-section__slide">
    <p v-text="slide.subtitle" class="subtitle" />

    <div class="gallery-section__slide-img-wrapper">
      <img :src="require('@/assets/img/gallery/' + lang + '/gallery-slide-' + index + '-1.'+ getResolution())" alt="avatar" />
      <img :src="require('@/assets/img/gallery/'+ lang + '/gallery-slide-' + index + '-2.'+ getResolution())" alt="avatar" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GallerySlide',
  props: {
    slide: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  methods: {
    getResolution() {
      return this.lang === 'en' ? 'png' : 'webp';
    },
  },
};
</script>
